import { observable, action, computed } from "mobx";
import { entities } from "sbtech-sports-data-api-client";
import { parseTimeFull } from "sb-resp-lib";

export type LiveGameStateType = {
    clockRunning: boolean;
    clockDirection: entities.ClockDirection;
    gameTime: number | null;
    gamePart: entities.GamePart | null;
};

export class LiveGameState implements entities.LiveGameState {
    clockRunning: boolean;
    clockDirection: entities.ClockDirection;
    @observable gameTime: number | null;
    @observable gamePart: entities.GamePart | null;
    constructor(data: LiveGameStateType) {
        this.clockRunning = data.clockRunning;
        this.clockDirection = data.clockDirection;
        this.gameTime = data.gameTime;
        this.gamePart = data.gamePart;
    }

    @action update(data: LiveGameStateType): void {
        if (this.shouldUpdateGameTime(data)) {
            this.gameTime = data.gameTime;
        }
        this.gamePart = data.gamePart;
        this.clockDirection = data.clockDirection;
        this.clockRunning = data.clockRunning;
    }

    @action updateGameTime(gameTime: number): void {
        this.gameTime = gameTime;
    }

    @computed get formattedTime(): string {
        if (this.gameTime !== null) {
            return parseTimeFull(this.gameTime);
        }
        return "";
    }

    // as the api dosn't provide a timestamp for calculation the delta
    // this hack prevents from jumps of the clock on every update
    private shouldUpdateGameTime(data: LiveGameStateType): boolean {
        return !data.clockRunning || !this.gameTime || !data.gameTime || data.gameTime > this.gameTime;
    }
}